// extracted by mini-css-extract-plugin
export default {"DownloadsPage":"DownloadsPage__DownloadsPage___aiXzI"};